<template>
  <div class="page--crud">
    <div>
      <div class="titleDiv">
        <h3 class="title">Empresas</h3>
        <router-link
          to="/master/create-companies"
          exact
          tag="li"
          :title="'Criar empresas'"
          v-tippy="{
            placement: 'right',
            theme: 'light',
            inertia: true,
            arrow: true,
            animation: 'perspective',
          }"
          class="box-add-icon"
        >
          <fa size="lg" icon="plus" />
        </router-link>
      </div>
      <app-company-list-filter
        ref="filter"
        :loading="loading"
        @clean-selection="selectedItems = []"
        @search="search($event)"
      ></app-company-list-filter>
      <app-grid
        ref="grid"
        v-model="selectedItems"
        :noSelection="true"
        :columns="columns"
        :rows="rows"
        :total="totalItems"
        :loading="loading"
      >
        <div
          class="summary"
          style="display: flex; justify-content: space-between; align-items: center"
        >
          <div style="display: flex;">
            <div class="summary__item">
              <span>Total de itens</span>
              <h3>{{ totalItems }}</h3>
            </div>
          </div>
          <div>
            <app-pagination
              :currentPage="currentPage"
              :totalPages="getTotalPages"
              @pagechanged="onPageChange"
            ></app-pagination>
          </div>
        </div>
        <template slot="actions" slot-scope="slotProps">
          <div
            style="display: flex; justify-content: space-between; align-items: center;"
          >
            <div>
              <a
                href="javascript:void(0)"
                class="edit-row"
                @click.stop="editZepplinTax(slotProps.row.id)"
              >
                <icon-edit></icon-edit>
              </a>
            </div>
            <div>
              <a
                href="javascript:void(0)"
                class="edit-row"
                @click.stop="editCompany(slotProps.row.id)"
              >
                O
              </a>
            </div>
          </div>
        </template>
      </app-grid>

      <div class="footer">
        <!-- <div class="left-side" style="padding-left: 0;">
                    <img :src="logoSrc" style="margin-left: 0" />
                </div>
                <span class="push-both-sides"></span> -->
      </div>
    </div>

    <app-modal
      style="width: 100%; z-index: 99999;"
      v-if="showCompanyTaxesEdit"
      @close="closeCompanyTaxesEdit()"
      btnActionName="Salvar"
      @action="submitCompanyTaxEdit()"
    >
      <template slot="header">
        <div style="margin-right: 20px; color: #C3C5C6;">
          EDITAR TAXAS DA EMPRESA
        </div>
      </template>
      <template slot="body">
        <div
          style="display: flex; justify-content: space-between; align-items: center;"
        >
          <div style="text-align: left; margin-right: 15px;">
            Taxa sobre pagamento online (%)
            <input
              type="text"
              class="input input-config"
              style="margin-bottom: 0;"
              v-model="companyTaxForm.creditCardTax"
            />
          </div>
          <div style="text-align: left;">
            Taxa sobre o pedido Zepplin (%)
            <input
              type="text"
              class="input input-config"
              style="margin-bottom: 0;"
              v-model="companyTaxForm.requestTax"
            />
          </div>
        </div>
      </template>
    </app-modal>

    <app-modal
      style="width: 100%; z-index: 99999;"
      v-if="showCompanyEdit"
      @close="closeCompanyEdit()"
      btnActionName="Salvar"
      @action="submitCompanyEdit()"
    >
      <template slot="header">
        <div style="margin-right: 20px; color: #C3C5C6;">
          EDITAR EMPRESA {{ companyForm.name }}
        </div>
      </template>
      <template slot="body">
        <div
          style="display: flex; justify-content: space-between; align-items: center;"
        >
          <div style="text-align: left; margin-right: 15px;">
            Telefone para contato
            <app-mask
              :mask="['(##) ####-####', '(##) #####-####']"
              v-model="companyForm.phoneNumber"
              placeholder="(##) #####-####"
              class="input input-config"
              style="margin-bottom: 0;"
            ></app-mask>
          </div>
        </div>
        <div style="margin-top: 20px;">
          <app-switch
            class="switch-toggle"
            v-model="companyForm.isActive"
            :label="
              `Empresa ${
                companyForm.isActive ? 'ativada' : 'desativada'
              } no Zepplin`
            "
          />
        </div>
      </template>
    </app-modal>
  </div>
</template>
<script>
import { mapGetters, mapState, mapActions } from "vuex";

import moment from "moment";
import _ from "lodash";

import CompaniesAPI from "../../../api/companies";
import ZepplinCompaniesAPI from "../../../api/zepplin/companies";
import CompaniesListFilterComponent from "./CompaniesListFilter.vue";
import { GridCore } from "../../../components/Utilities/Grid/index";
import { Portuguese } from "flatpickr/dist/l10n/pt";
import PaginationComponent from "../../../components/Utilities/Pagination.vue";

export default {
  components: {
    "app-company-list-filter": CompaniesListFilterComponent,
    "app-grid": GridCore,
    "app-pagination": PaginationComponent,
  },
  data() {
    return {
      logoSrc: require("../../../assets/imgs/logo-2018.png"),
      filterData: [],
      ordinationData: {},
      currentPage: 1,
      offset: 0,
      limit: 50,
      totalItems: 0,
      totalAmount: 0,
      totalZepplinTax: 0,
      selectedItems: [],
      rows: [],
      columns: [
        {
          text: "Empresa",
          name: "name",
        },
        {
          text: "Data de criação",
          name: "dateCreated",
          width: 130,
        },
        {
          text: "Pedidos finalizados",
          name: "requestsFinished",
          width: 160,
        },
        {
          text: "Pedidos cancelados",
          name: "requestsCanceled",
          width: 165,
        },
        {
          text: "Taxa p/ pedido",
          name: "requestTax",
          width: 140,
          style: {
            "justify-content": "center",
          },
        },
        {
          text: "Taxa p/ pagamento",
          name: "creditCardTax",
          width: 150,
          style: {
            "justify-content": "center",
          },
        },
        {
          text: "Status",
          name: "status",
          width: 160,
          style: {
            "justify-content": "center",
          },
        },
        {
          text: "Ações",
          name: "actions",
          style: {
            "justify-content": "center",
          },
          width: 72,
        },
      ],
      filterForm: {
        search: null,
      },
      loading: true,
      datetimeSelectorConfig: {
        altInput: true,
        altFormat: "d/m/Y H:i:S",
        dateFormat: "Z",
        locale: Portuguese,
        time_24hr: true,
        enableTime: true,
      },
      showCompanyEdit: false,
      showCompanyTaxesEdit: false,
      companyForm: {
        status: null,
        phoneNumber: null,
        isActive: null,
      },
      companyTaxForm: {
        requestTax: null,
        creditCardTax: null,
      },
    };
  },
  computed: {
    ...mapState("auth", ["zepplinMasterToken"]),
    accountsSelectItems() {
      return _.map(this.accounts, (account) => {
        return {
          value: account.id,
          text: account.name,
        };
      });
    },
    getTotalPages() {
      return this.totalItems <= this.limit
        ? 1
        : (!Number.isInteger(this.totalItems / this.limit)
            ? Math.trunc(this.totalItems / this.limit)
            : this.totalItems / this.limit - 1) + 1;
    },
  },
  methods: {
    ...mapActions("toast", ["showToast", "showError"]),

    redirectWhatsApp(phoneNumber) {
      window.open("https://wa.me/55" + phoneNumber);
    },

    async editZepplinTax(zepplinCompanyId) {
      try {
        this.showCompanyTaxesEdit = true;
        const { data } = await ZepplinCompaniesAPI.get(zepplinCompanyId, {
          hasInclude: true,
        });
        Object.assign(this.companyTaxForm, data.companyTax);
      } catch (err) {
        console.error(err);
        this.showError("Não foi possível editar as taxas da empresa.");
      }
    },

    async editCompany(companyId) {
      const vm = this;
      try {
        this.showCompanyEdit = true;
        const { data } = await CompaniesAPI.getCompany(companyId, {
          byZepplinId: true,
        });
        Object.assign(this.companyForm, {
          ...data,
        });
        this.companyForm.isActive =
          this.companyForm.status !== "inactive" ? true : false;
      } catch (err) {
        console.log("Error occurred", err);
      }
    },

    search({ filterData = null, ordinationData = null } = {}) {
      this.loading = true;
      if (filterData) this.filterData = filterData;
      if (ordinationData) this.ordinationData = ordinationData;

      this.currentPage = 1;
      this.offset = 0;

      const filters = {
        offset: this.offset,
        limit: this.limit,
        search: this.filterData.search,
      };
      const ordinations = {
        ...ordinationData,
      };
      const requestParams = {
        ...filters,
        ...ordinations,
      };
      this.updateFilter(requestParams);
    },

    async submitCompanyEdit() {
      this.loading = true;
      try {
        let status;
        if (this.companyForm.isActive) status = "unavailable";
        else status = "inactive";
        await CompaniesAPI.update(
          { ...this.companyForm, status },
          { toMaster: true }
        );
        await ZepplinCompaniesAPI.updateCompany(this.companyForm.zepplinId, {
          status,
        });
        this.showToast({
          type: "success",
          message: "Empresa atualizada com sucesso!",
        });
      } catch (err) {
        console.error(err);
        this.showError("Algo deu errado! Não foi possível atualizar empresa.");
      }
      this.loading = false;
    },

    async submitCompanyTaxEdit() {
      try {
        const companyTaxForm = this.handleCompanyTaxForm(this.companyTaxForm);
        await ZepplinCompaniesAPI.updateCompanyTax(
          this.companyTaxForm.id,
          companyTaxForm,
          { masterToken: this.zepplinMasterToken }
        );
        this.showToast({
          type: "success",
          message: "Taxas da empresa atualizadas com sucesso!",
        });
      } catch (err) {
        this.showError("Não foi possível atualizar taxas da empresa.");
      }
    },

    handleCompanyTaxForm({ requestTax, creditCardTax }) {
      return {
        requestTax: parseFloat(requestTax),
        creditCardTax: parseFloat(creditCardTax),
      };
    },

    closeCompanyEdit() {
      this.companyForm = {
        name: "",
        zepplinTaxInPercent: null,
        status: null,
        phoneNumber: null,
        isActive: null,
      };
      this.showCompanyEdit = false;
    },

    closeCompanyTaxesEdit() {
      this.companyTaxForm = {
        requestTax: null,
        creditCardTax: null,
      };
      this.showCompanyTaxesEdit = false;
    },

    onPageChange(page) {
      this.currentPage = page;
      this.offset = parseInt(`${page - 1}0`);
      const filters = {
        limit: this.limit,
        offset: this.offset * 5,
        search: this.filterData.search,
      };
      const ordinations = this.utils.removeReactivity(this.ordinations);
      const requestParams = {
        ...filters,
        ...ordinations,
      };
      this.updateFilter(requestParams);
    },
    updateFilter(requestParams) {
      const vm = this;

      this.loading = true;
      ZepplinCompaniesAPI.getReportCompanies(requestParams)
        .then(({ data }) => {
          vm.rows = _.map(data.rows, vm.upsertRow);
          this.totalItems = data.count;
          this.loading = false;
        })
        .catch((err) => {
          console.error(err);
          this.showError("Não foi possível carregar a lista.");
          this.loading = false;
        });
    },
    upsertRow(row) {
      const vm = this;
      return {
        id: row.id,
        companyId: row.id,
        columns: [
          {
            column: "name",
            text: row.name,
            showTitle: true,
          },
          {
            column: "dateCreated",
            text: moment(row.dateCreated).format("DD/MM/YYYY"),
          },
          {
            column: "requestsFinished",
            text: row.requestsFinished ? row.requestsFinished : 0,
          },
          {
            column: "requestsCanceled",
            text: row.requestsCanceled ? row.requestsCanceled : 0,
          },
          {
            column: "requestTax",
            text: (row.companyTax ? row.companyTax.requestTax : 0) + "%",
            style: {
              "justify-content": "center",
            },
          },
          {
            column: "creditCardTax",
            text: (row.companyTax ? row.companyTax.creditCardTax : 0) + "%",
            style: {
              "justify-content": "center",
            },
          },
          {
            column: "status",
            text: row.status === "inactive" ? "INATIVO" : "ATIVO",
            style: {
              "justify-content": "center",
            },
          },
          {
            column: "actions",
            html: true,
            style: {
              "justify-content": "center",
            },
          },
        ],
        payload: {
          id: row.id,
        },
      };
    },
  },
  async mounted() {
    await this.search({ filterData: this.filterForm });
  },
  beforeDestroy() {},
};
</script>

<style lang="scss">
.input-config {
  border-bottom: 1px solid #525662;
  width: 100%;
}
.page--crud {
  display: flex;
  width: 100%;
  justify-content: center;
  background-color: var(--bg-color--7);

  a.column-received {
    color: var(--font-color);
    &.active {
      color: var(--font-color--primary);
    }
    background-color: transparent;
  }

  a.edit-row {
    padding: 0 5px;
  }

  a.edit-row .colorizable {
    fill: var(--font-color);
  }

  a.edit-row:hover .colorizable {
    fill: var(--font-color--primary);
  }

  /* title */

  .titleDiv {
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  h3.title {
    font-size: 16px;
    text-transform: uppercase;
    color: var(--font-color--7);
    margin-right: 20px;
  }

  /* filter */

  ul.filter-menu {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    padding-bottom: 20px;
  }
  ul.filter-menu li {
    margin: 0 5px;
    position: relative;
  }
  ul.filter-menu >>> li.datetime-selector input {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    position: absolute;
    overflow: hidden;
    z-index: -1;
  }
  ul.filter-menu li a {
    height: 32px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    color: var(--font-color--7);
  }
  ul.filter-menu li a.right-padding {
    padding-right: 30px;
  }
  ul.filter-menu li a.clear-filter {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  ul.filter-menu li a .primary {
    color: var(--font-color--primary);
    font-weight: 600;
  }
  ul.filter-menu li a .dot-separator.primary {
    background-color: var(--border-color--primary);
  }
  ul.filter-menu li a .secondary {
    color: var(--font-color--secondary);
    font-weight: 600;
  }
  ul.filter-menu li a .dot-separator.secondary {
    background-color: var(--border-color--secondary);
  }
  ul.filter-menu li a .terciary {
    color: var(--font-color--terciary);
    font-weight: 600;
  }
  ul.filter-menu li a .dot-separator.terciary {
    background-color: var(--border-color--terciary);
  }

  /* summary */

  .summary {
    display: flex;
    flex-direction: row;
    flex-shrink: 0;
    padding: 20px 20px;
    border-top: 1px solid var(--bg-color--8);

    .summary__item {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      padding: 0 20px;
      border-right: 1px solid var(--bg-color--8);
    }

    .summary__item.border-left {
      border-left: 1px solid var(--bg-color--8);
    }

    .summary__item:last-child {
      border-right: 0;
    }
  }

  /* footer */

  div.footer {
    padding: 40px 0;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
  }

  div.footer a {
    text-transform: uppercase;
  }

  div.footer span {
    font-weight: 600;
  }

  div.footer .left-side {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding-left: 20px;
  }

  div.footer .left-side > * {
    margin: 0 5px;
  }

  div.footer .right-side {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding-right: 20px;
  }

  div.footer .right-side .group {
    border: 1px solid var(--bg-color--9);
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 15px;
    border-radius: 10px;
    margin-right: 10px;
    height: 32px;
  }

  div.footer .right-side > a {
    height: 30px;
  }

  div.footer .right-side .group .dot-separator {
    margin: 0 10px;
  }

  div.footer .right-side .group span {
    margin-right: 10px;
    white-space: nowrap;
  }

  div.footer .right-side > * {
    margin: 0 5px;
  }

  div.footer .right-side > *:last-child {
    margin: 0 0 0 5px;
  }
}
.page--crud > div {
  width: 96%;
  text-align: center;
  padding-top: 40px;
  display: flex;
  flex-direction: column;
}
.page--crud > div > h3 {
  padding-bottom: 30px;
}

.datetime-selector {
  margin-bottom: 0;
  border: 0;
  margin-top: 0;
  padding: 0;
  &:hover,
  &:active,
  &:focus {
    margin-bottom: 0;
    border: 0;
    margin-top: 0;
    padding: 0;
  }
}

.box-add-icon {
  width: 50px;
  height: 30px;
  border-radius: 50px;
  background: linear-gradient(89.39deg, #0072e4 -0.59%, #25a0a8 100.95%);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.box-add-icon:hover {
  background: #0072e4;
}
</style>
